import React, { memo, forwardRef } from "react";
const SvgClear = forwardRef((props, svgRef) => {
  return (
    <svg
      width={32}
      height={32}
      fill="none"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <path
        fill="#717171"
        fillRule="evenodd"
        d="M12.102 8.294A1 1 0 0112.81 8H26a1 1 0 011 1v14a1 1 0 01-1 1H12.81a1 1 0 01-.708-.294l-6.984-7a1 1 0 010-1.412l6.984-7zM12.81 6a3 3 0 00-2.123.881l-6.985 7a3 3 0 000 4.238l6.985 7A3 3 0 0012.81 26H26a3 3 0 003-3V9a3 3 0 00-3-3H12.81zm1.483 5.293a1 1 0 011.414 0L19 14.586l3.293-3.293a1 1 0 011.414 1.414L20.414 16l3.293 3.293a1 1 0 01-1.414 1.414L19 17.414l-3.293 3.293a1 1 0 01-1.414-1.414L17.586 16l-3.293-3.293a1 1 0 010-1.414z"
        clipRule="evenodd"
      />
    </svg>
  );
});
SvgClear.displayName = "SvgClear";
const MemoForwardRef = memo(SvgClear);
export default MemoForwardRef;
